import { Input } from 'antd';
import clsx from 'clsx';
import DollarInputPayment from 'components/DollarAmount/DollarInputPayment';
import { get } from 'lodash';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import { MULTI_PAYMENT_TYPES, multiPaymentConfigs } from './constants';
type Props = {
  viewOnly?: boolean;
  amount?: number;
  code?: string;
  available?: number;
};
const GiftCardPaymentItemView = ({ available = 0, code = '', amount = 0, }: Props) => {
  const config = get(multiPaymentConfigs, MULTI_PAYMENT_TYPES.GIFT_CARD);
  const balance = available ? available - amount : 0;

  if (!config) return null;

  return (
    <Container className={clsx('payment-item')}>
      <div className="payment-label">
        <img src={config.icon} alt={config.label} style={{ width: 48, height: 48 }} />
        <span>{config.label}</span>
      </div>

      <DollarInputPayment
        inputMode='none'
        disabled
        value={amount}
      />
      <SubContentStyled>
        <Input
          placeholder="Code"
          disabled
          value={code}
        />
        <FeeRow className='point'><span>Available:</span> <span>{formatCurrency(available)}</span></FeeRow>
        <FeeRow className={clsx('point', balance < 0 && 'minus')}><span>Balance:</span> <span>{formatCurrency(balance)}</span></FeeRow>
      </SubContentStyled>
      <TotalContentStyled>
        <span>{formatCurrency(amount)}</span>
      </TotalContentStyled>
    </Container>
  );
};

export default GiftCardPaymentItemView;
const TotalContentStyled = styled.div`
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-top: 1px solid #CCD4DC;
  background: #FFF;
  box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #D6D6E7 inset;
  span {
    align-self: stretch;
    text-align: center;
    color: #1D2129;
    font-family: Poppins;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;
const SubContentStyled = styled.div`
  flex: 1;
  background: #F6F7FC;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  margin-top: 0px;
  padding: 8px 16px;
  border-top: 1px solid #CCD4DC;
  .ant-input {
    display: flex;
    height: 56px;
    padding: 0px 24px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid #86909C;
    background: #FFF;
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    &::placeholder {
      color: #1D2129;
      opacity: 1;
    }

    &::-ms-input-placeholder {
      color: #1D2129;
    }

    &:disabled {
      color: #1D2129;
    }
    &[aria-invalid="true"] {
      border-radius: 4px;
      border: 1px solid #D2464F;
      background: #FFF;
      box-shadow: 0px 0px 0px 3px rgba(208, 51, 63, 0.10);
    }
  }
`;
const FeeRow = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  justify-content: space-between;
  padding: 0;
  height: 56px;
  &.point {
  height: auto;
  }
  span {
    color: #1D2129;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  &.minus {
    span {
      color: red;
    }
  }
`;
const Container = styled.div`
&.payment-item {
    .ant-form-item-explain-error {
      text-align: center;
      color: #f53f3f;
    }
    width: 270px;
    display: flex;
    align-self: stretch;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #D6D6E7 inset;
    position: relative;
    z-index: 1;
    &.button:hover {
      cursor: pointer;
    }
    .overlay {
      position: absolute;
      z-index:99;
      inset: 0;
    }
    div.payment-label {
      display: flex;
      align-items: center;
      gap: 4px;
      height: 42px;
      align-self: stretch;
      justify-content: center;
      margin-bottom: 12px;
      padding-top: 8px;
      span {
        color: #C84B31;
        text-align: center;
        font-family: Poppins;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-transform: uppercase;
      }

      &.button:hover {
        cursor: pointer;
      }
    }

    .dollar-input-selector {
      margin: 0 16px;
      align-self: stretch;
      height: 3.5rem;
      justify-content: center;
      margin-bottom: 24px;
      .dollar-input-text {
        font-size: 32px;
        color: #1D2129;
        font-weight: 600;
      }

      &[aria-disabled="true"], &[aria-disabled="true"] input {
        background: #eee;
        opacity: 0.8;
      }
    }
  }
`;
